import {
  WEEKS_CREATE_FAIL,
  WEEKS_CREATE_REQUEST,
  WEEKS_CREATE_SUCCESS,
  WEEKS_LIST_FAIL,
  WEEKS_LIST_REQUEST,
  WEEKS_LIST_SUCCESS,
  WEEKS_UPDATE_FAIL,
  WEEKS_UPDATE_REQUEST,
  WEEKS_UPDATE_SUCCESS,
  WEEKS_PATCH_FAIL,
  WEEKS_PATCH_REQUEST,
  WEEKS_PATCH_SUCCESS,
  WEEKS_SINGLE_REQUEST,
  WEEKS_SINGLE_SUCCESS,
  WEEKS_SINGLE_FAIL,
} from "../constants/weekConstants";
import axios from "axios";
import createAuthConfig from "../utils/createAuthConfig";

// Define the API_URL using the environment variable
const API_URL = process.env.REACT_APP_API_URL;

export const listWeeks = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: WEEKS_LIST_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/weeks/`, config);

    dispatch({
      type: WEEKS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: WEEKS_LIST_FAIL,
      payload: message,
    });
  }
};

export const getWeekbyIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: WEEKS_SINGLE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/weeks/week/${id}`, config);

    dispatch({
      type: WEEKS_SINGLE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: WEEKS_SINGLE_FAIL,
      payload: message,
    });
  }
};

export const createWeekAction =
  (objectives, columnOrder) => async (dispatch, getState) => {
    try {
      dispatch({
        type: WEEKS_CREATE_REQUEST,
      });

      const config = createAuthConfig();

      // Use the dynamic API_URL
      const { data } = await axios.post(
        `${API_URL}/api/weeks/week/create`,
        { objectives, columnOrder },
        config
      );

      await dispatch({
        type: WEEKS_CREATE_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: WEEKS_CREATE_FAIL,
        payload: message,
      });
    }
  };

// Patch-style update for Week — same protocol as Day / Year. Week only
// has two patchable top-level fields (objectives, columnOrder); the
// server enforces the allow-list.
export const patchWeekAction =
  (id, { patches, clientFieldTimestamps, deviceId, socketId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: WEEKS_PATCH_REQUEST });
      const config = createAuthConfig();
      const { data } = await axios.patch(
        `${API_URL}/api/weeks/week/${id}`,
        { patches, clientFieldTimestamps, deviceId, socketId },
        config,
      );
      dispatch({ type: WEEKS_PATCH_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: WEEKS_PATCH_FAIL, payload: message });
      throw new Error(message);
    }
  };

export const updateWeekAction =
  (id, objectives, columnOrder) => async (dispatch, getState) => {
    try {
      dispatch({
        type: WEEKS_UPDATE_REQUEST,
      });

      const config = createAuthConfig();

      // Use the dynamic API_URL
      const { data } = await axios.put(
        `${API_URL}/api/weeks/week/${id}`,
        {
          objectives,
          columnOrder,
        },
        config
      );

      await dispatch({
        type: WEEKS_UPDATE_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: WEEKS_UPDATE_FAIL,
        payload: message,
      });
    }
  };
